import { eClientContactActionType } from '../../types/contacts/eClientContactActionType';
import { OpenLinkInNewTab } from 'ui-toolkit';
import React from 'react';

interface IGetContactSuccessMessageProps {
  actionType: eClientContactActionType;
  resetPasswordUrl?: string;
  email: string;
}

export const GetContactSuccessMessage: React.FC<IGetContactSuccessMessageProps> = ({
  actionType,
  email,
  resetPasswordUrl,
}) => (
  <>
    {actionType === eClientContactActionType.Deactivate && `The user has been deactivated`}
    {actionType === eClientContactActionType.Activate && `The user has been activated`}
    {actionType === eClientContactActionType.Invite && `The invitation email has been sent`}
    {actionType === eClientContactActionType.ResetPassword && (
      <div>
        <span>Password reset email sent. Get reset link </span>
        <OpenLinkInNewTab onClick={() => {}} href={resetPasswordUrl || ''} text={'here.'} isActive isInline />
      </div>
    )}
    {actionType === eClientContactActionType.ReinviteUser && `An invitation has been sent to ${email}`}
  </>
);
